import type { SerialNumber } from "~domain/devices/models/common-device-model.ts";
import type { ModulatorCsId, ModulatorHwId } from "~domain/devices/models/modulators/modulator-model.ts";
import type { PilotHwId } from "~domain/devices/models/pilot/pilot-model.ts";
import type { OperatorId } from "~domain/operators/models/operator-model.ts";
import type { SiteId } from "~domain/sites/models/site-model.ts";
import type { SitePhotoId } from "~domain/sites/models/site-photo-model.ts";

import { z } from "zod";

export const backofficeFindSitePhotosResponseSchema = z
  .object({
    applianceTypeAndLocalisation: z.object({
      type: z.string(),
      localisation: z.string().nullable(),
    }),
    creationDateTime: z.coerce.date(),
    csModulatorId: z
      .number()
      .transform((s) => s as ModulatorCsId)
      .nullable(),
    deviceSerial: z
      .string()
      .transform((s) => s as SerialNumber)
      .nullable(),
    fileName: z.string(),
    hash: z.string(),
    hwModulatorId: z
      .number()
      .transform((s) => s as ModulatorHwId)
      .nullable(),
    hwMomboxId: z
      .number()
      .transform((s) => s as PilotHwId)
      .nullable(),
    id: z.string().transform((s) => s as SitePhotoId),
    personFirstName: z.string().nullable(),
    personId: z
      .number()
      .transform((s) => s as OperatorId)
      .nullable(),
    personLastName: z.string().nullable(),
    photoTypeRefId: z.number(),
    siteId: z.number().transform((s) => s as SiteId),
    uploadDateTime: z.coerce.date(),
    url: z.string(),
  })
  .array();

export type BackofficeFindSitePhotosResponse = z.infer<typeof backofficeFindSitePhotosResponseSchema>;
